import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  LayoutDashboard, 
  ShoppingCart, 
  Users, 
  UserCheck, 
  Package, 
  PenTool,
  Grid3x3,
  X
} from 'lucide-react';

interface SidebarProps {
  isOpen: boolean;
  onClose: () => void;
}

const navigation = [
  { name: 'Dashboard', href: '/dashboard', icon: LayoutDashboard },
  { name: 'Orders', href: '/orders', icon: ShoppingCart },
  { name: 'Leads', href: '/leads', icon: Users },
  { name: 'Technicians', href: '/technicians', icon: UserCheck },
  { name: 'Products', href: '/products', icon: Package },
  { name: 'Product Grid', href: '/products/grid', icon: Grid3x3 },
  { name: 'Content Creator', href: '/content-creator', icon: PenTool },
];

const Sidebar: React.FC<SidebarProps> = ({ isOpen, onClose }) => {
  const location = useLocation();

  return (
    <>
      {/* Mobile backdrop */}
      {isOpen && (
        <div className="fixed inset-0 z-40 lg:hidden" onClick={onClose}>
          <div className="fixed inset-0 bg-gray-600 bg-opacity-75"></div>
        </div>
      )}

      {/* Sidebar */}
      <div className={`
        fixed top-0 left-0 z-50 h-full w-64 bg-gradient-to-b from-white to-gray-50 shadow-strong transform transition-transform duration-300 ease-in-out
        lg:translate-x-0 border-r border-gray-200/60
        ${isOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
      `}>
        <div className="flex items-center justify-between h-16 px-6 border-b border-gray-200/60 bg-gradient-to-r from-primary-600 to-primary-700">
          <div className="flex items-center">
            <h1 className="text-xl font-bold text-white">🚀 Minto Admin</h1>
          </div>
          <button
            onClick={onClose}
            className="lg:hidden p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100"
          >
            <X className="h-6 w-6" />
          </button>
        </div>

        <nav className="mt-6 px-3">
          <div className="space-y-1">
            {navigation.map((item) => {
              const isActive = location.pathname === item.href || 
                             (item.href === '/orders' && location.pathname.startsWith('/orders')) ||
                             (item.href === '/products' && location.pathname.startsWith('/products') && !location.pathname.startsWith('/products/grid')) ||
                             (item.href === '/products/grid' && location.pathname.startsWith('/products/grid'));
              const Icon = item.icon;
              
              return (
                <Link
                  key={item.name}
                  to={item.href}
                  onClick={onClose}
                  className={`
                    sidebar-link w-full
                    ${isActive ? 'active' : ''}
                  `}
                >
                  <Icon className="h-5 w-5 mr-3" />
                  {item.name}
                </Link>
              );
            })}
          </div>
        </nav>
      </div>
    </>
  );
};

export default Sidebar; 